<script>
export default {
  data: () => ({
    timeOutId: null
  }),
  created () {
    /*
    this.timeOutId = setTimeout(() => {
      alert('エラーが発生しました。ページを再読み込みします。')
      location.reload()
    }, 10000)
    */
  },
  destroyed () {
    clearTimeout(this.timeOutId)
  }
}
</script>

<template>
  <div class="screen">
    <div class="loader"></div>
    <p class="is-cs-1 is-c-text has-text-weight-bold">Loading...</p>
  </div>
</template>



// WEBPACK FOOTER //
// src/components/view-model/loading-screen.vue